module.exports = __webpack_public_path__ + "static/grafika3-bbe48b32a0b489f98a0902322e0f4e4a.png";